import { CardBrandData, CardBrandConfig, MerchantCardPreference, WebGivingMerchant } from '../webgiving-generated';
import { ApplePayMerchantCapabilities, ApplePaySupportedNetworks } from '../webgiving-payment-state';

export function getCardBrandByInput(input: string) {
	for (let b of CardBrandData) {
		if (b.pattern.test(input)) {
			return b;
		}
	}
	return null;
}

export function getCardBrandByKey(key: string) {
	for (let b of CardBrandData) {
		if (b.key === key) {
			return b;
		}
	}

	return null;
}

export function getCardBrandsFromKeys(brandKeys: string[]) {
	return brandKeys.map(getCardBrandByKey).filter((x) => x) as CardBrandConfig[];
}

export function getApplePayNetworksAndCapabilities(merchant: WebGivingMerchant) {
	const { SupportedCardBrandKeys, CardPreference } = merchant;
	const supportsCards = SupportedCardBrandKeys && SupportedCardBrandKeys.length > 0;

	if (supportsCards) {
		let merchantCapabilities: ApplePayMerchantCapabilities[] = [];
		switch (CardPreference) {
			case MerchantCardPreference.AnyCard:
			case MerchantCardPreference.DebitPreferred:
				merchantCapabilities = [
					ApplePayMerchantCapabilities.Supports3DS,
					ApplePayMerchantCapabilities.SupportsCredit,
					ApplePayMerchantCapabilities.SupportsDebit,
				];
				break;
			case MerchantCardPreference.DebitOnly:
				merchantCapabilities = [
					ApplePayMerchantCapabilities.Supports3DS,
					ApplePayMerchantCapabilities.SupportsDebit,
				];
				break;
		}

		return {
			supportedNetworks: getCardBrandsFromKeys(SupportedCardBrandKeys).map(
				(b) => ApplePaySupportedNetworks[b.shortName as any]
			),
			merchantCapabilities,
		};
	}

	return false;
}
